export default __webpack_public_path__ + "static/media/c4b6fcf09e03217c2d3af03e4b28a4fc1579790128173.9017d5cb.webp";